export enum FeatureFlags {
  SampleFlag = 'sample-flag', // Don't remove, some code does not like it when it is empty
  NonSponsoredTransactionsEnabled = 'non-sponsored-transactions-enabled',
  UseAlchemyBundlerClient = 'use-alchemy-bundler-client',
  TournamentSatellites = 'tournament-satellites',
  ScheduledMaintenance = 'scheduled-maintenance',
  AnalyticsDashboard = 'analytics-dashboard',
  CustomAgentDeals = 'custom-agent-deals',
  MasterAgent = 'master-agent',
  ReferralStatsEnabled = 'referral-stats-enabled',
  SubAgentCreationPermissions = 'sub-agent-creation-permissions',
  KycWalletCheck = 'kyc-wallet-check',
}
